import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { from, Observable } from 'rxjs';
import * as translate from "translate";

@Component({
    selector: 'mono-common-show-hide-password-toggle',
    templateUrl: './show-hide-password-toggle.component.html',
})
export class ShowHidePasswordToggleComponent implements OnInit {

  private readonly defaultLanguage = "en";

  @Input() language: string = this.defaultLanguage;

  @Output() showToggle = new EventEmitter<boolean>();

  public showPassword = false;
  public toggleShowPasswordAriaLabel: Observable<string>;
  public showText: Observable<string>;
  public hideText: Observable<string>;

  constructor() { }

  ngOnInit(): void {
    this.showText = from<string>(translate(this.language == this.defaultLanguage ? "show" : "show", this.language));
    this.hideText = from<string>(translate(this.language == this.defaultLanguage ? "hide" : "hide", this.language));
    this.toggleShowPasswordAriaLabel = from<string>(translate("Show or hide your password on screen", this.language));
  }

  public showToggleEmit() {
    this.showPassword = !this.showPassword;
    this.showToggle.emit(this.showPassword);
  }

  public preventFocusOnElement(event) {
    event.preventDefault();
  }

}